/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Claimant_DriverInputs */

const en_reports_col_claimant_driver = /** @type {(inputs: Reports_Col_Claimant_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant driver`)
};

const pt_br2_reports_col_claimant_driver = /** @type {(inputs: Reports_Col_Claimant_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorista Requerente`)
};

/**
* | output |
* | --- |
* | "Claimant driver" |
*
* @param {Reports_Col_Claimant_DriverInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_claimant_driver = /** @type {((inputs?: Reports_Col_Claimant_DriverInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Claimant_DriverInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_claimant_driver(inputs)
	return pt_br2_reports_col_claimant_driver(inputs)
});